module.exports = __webpack_public_path__ + "img/pijltje-rechts-wit.b84c28114cb3aae6f1277292b58e8669.svg";